//imports
import {
    EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL,
    EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST,
    EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    deviceModel: null,
    alertTypes: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, deviceModel: action.payload.deviceModel, alertTypes: action.payload.alertTypes }

        case EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST:
            return { ...state, loading: true }

        case EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "EDIT_ALERT_TYPE_SUPPORTED"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
